module.exports = __webpack_public_path__ + "static/img/dialog-icon.3d88a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/dialog-icon.png
// module id = 8Sam
// module chunks = 1